import { render } from "./MovementFlock.vue?vue&type=template&id=84e00764"
import script from "./MovementFlock.vue?vue&type=script&lang=js"
export * from "./MovementFlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__